<template>
  <a @click="handleMenuClick()"
     :href="url"
     :target="target" >{{ name }}</a>
</template>
<script>
  export default {
    name: 'grid-menu-a',
    props: {
      name: {
        type: String,
        default() {
          return 'MENU'
        }
      },
      target: {
        type: String,
        default() {
          return '_self'
        }
      },
      url: {
        type: String,
        default() {
          return 'javascript:'
        }
      }
    },
    computed: {
    },
    methods: {
      handleMenuClick() {
        this.$emit('menu-click')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/grid-menu/grid-menu-a.vue